module.exports = __webpack_public_path__ + "logo.f2c8249dabcd4ede93be.png";


//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/srd-poliflex-pipeline/src/img/logo.png
// module id = ../../../../../src/img/logo.png
// module chunks = styles